import { FormattedMessage, useIntl } from 'react-intl';
import Modal from '@/shared/components/Modal';
import ErrorAlert from '@/shared/components/ErrorAlert';
import ModalButton from '@/shared/components/ModalButton';
import RefundNotice from '@/shared/components/RefundNotice';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  error: string | null;
}

export default function PauseScheduleModal({ isOpen, onClose, onConfirm, isSubmitting, error }: Props) {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage({ id: 'schedule.pause.title' })}
      eyebrow={intl.formatMessage({ id: 'schedule.pause.eyebrow' })}
      footer={
        <>
          <ModalButton type="button" onClick={onClose} disabled={isSubmitting} variant="secondary">
            <FormattedMessage id="schedule.pause.cancel" />
          </ModalButton>
          <ModalButton type="button" onClick={onConfirm} disabled={isSubmitting} variant="danger">
            {isSubmitting ? (
              <FormattedMessage id="schedule.pause.pausing" />
            ) : (
              <FormattedMessage id="schedule.pause.confirm" />
            )}
          </ModalButton>
        </>
      }
    >
      <div className="space-y-5">
        <p className="text-sm text-slate-600">
          <FormattedMessage id="schedule.pause.body" />
        </p>
        <RefundNotice />
        {error && <ErrorAlert message={error} />}
      </div>
    </Modal>
  );
}
